/** Shared responsive `sizes` for blog cards (home preview + listing + related). */
export const BLOG_CARD_GRID_IMAGE_SIZES =
  "(min-width: 1520px) 352px, (min-width: 1200px) calc((100vw - 112px) / 4), (min-width: 810px) calc((100vw - 80px) / 2), calc(100vw - clamp(48px, 8vw, 64px))";
